import { render, staticRenderFns } from "./editAdaptationFile.vue?vue&type=template&id=6bb48de5&scoped=true&"
import script from "./editAdaptationFile.vue?vue&type=script&lang=js&"
export * from "./editAdaptationFile.vue?vue&type=script&lang=js&"
import style0 from "./editAdaptationFile.vue?vue&type=style&index=0&id=6bb48de5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb48de5",
  null
  
)

export default component.exports